"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _en = _interopRequireDefault(require("i2l?query=sporks!../../../../lang/en.lyaml"));

var _legacyI18nInit = require("../../internal/legacyI18nInit");

var _default = function _default(Provider) {
  return Provider.register(_en.default, {
    getLocales: _legacyI18nInit.getLangEnabledLocales
  });
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/init/register/lazy/registerI18nTranslations.js
// module id = 452
// module chunks = 209 210 211 212 213